import { registerLocale, setDefaultLocale } from "react-datepicker";
import { bg, cs, de, enGB, hr, hu, it, pl, ro, sk, sl, uk } from "date-fns/locale";

// date-fns locales of the app languages. The app uses its own codes for
// Czech, Slovenian and Ukrainian. English uses the British locale, so weeks
// start on Monday like in the other languages.
const LOCALES = {
  bg,
  cz: cs,
  de,
  en: enGB,
  hr,
  hu,
  it,
  pl,
  ro,
  si: sl,
  sk,
  ua: uk,
};

Object.entries(LOCALES).forEach(([language, locale]) => registerLocale(language, locale));

// The locale of the date pickers for an app language, English when unknown.
export const datepickerLocale = (language) => {
  const code = String(language || "").slice(0, 2).toLowerCase();

  return LOCALES[code] ? code : "en";
};

// Month and day names of every date picker follow the app language.
export const applyDatepickerLocale = (language) => {
  const locale = datepickerLocale(language);
  setDefaultLocale(locale);

  return locale;
};
